import { gql } from '@apollo/client';

export const UPLOAD_FILE = gql`
  mutation singleUploadS3($file: Upload!) {
    singleUploadS3(file: $file) {
      id
      path
      filename
      mimetype
      encoding
    }
  }
`;

export const CREATE_SIGNED_S3_UPLOAD = gql`
  mutation createSignedS3Upload($name: String!, $contentType: String!, $replace: Boolean) {
    createSignedS3Upload(name: $name, contentType: $contentType, replace: $replace)
  }
`;

export const EXTRACT_PDF_IMAGES_TO_S3 = gql`
  mutation extractPdfImagesToS3($file_url: String!) {
    extractPdfImagesToS3(file_url: $file_url)
  }
`;
